import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiDivider from '@material-ui/core/Divider';

const font = {
  fontFamily: 'Roboto',
  letterSpacing: '0.3px',
  lineHeight: '21px',
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: '16px',
  color: '#121212',
  margin: 0,
};

export const useStyles = makeStyles(() => ({
  container: {
    marginTop: '-12px',
  },
  title: {
    ...font,
    padding: '0 16px',
    marginBottom: 32,
  },
  accordionTitle: {
    ...font,
    margin: '4px 0',
  },
  accordionContainer: {
    marginBottom: '36px',
  },
  notAvailable: {
    fontFamily: 'Roboto',
    letterSpacing: '0.3px',
    lineHeight: '36px',
    color: '#212529',
    margin: '50px auto',
    fontSize: '25px',
    padding: '40px',
    backgroundColor: '#efefef',
    textAlign: 'center',
  },
  referenceDate: {
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.4375px',
    color: '#1F1F1F',
  },
}));

export const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    color: '#666666',
    padding: 12,
  },
}))(TableCell);

export const Accordion = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

export const Divider = withStyles({
  root: {
    height: 2,
    backgroundColor: '#121212',
  },
})(MuiDivider);

export default useStyles;
